import Axios from "../../utils/axios";

// Create/Save comment or reply
export const createComment = async (payload) => {
  const response = await Axios.post("/comments/save", payload);
  return response.data;
};

// Update comment
export const updateComment = async (payload) => {
  const response = await Axios.post("/comments/update", payload);
  return response.data;
};

// Delete comment
export const deleteComment = async (payload) => {
  const response = await Axios.post("/comments/delete", payload);
  return response.data;
};

// Read comments with filters
export const readComments = async (payload) => {
  const response = await Axios.post("/comments/read", payload);
  return response.data;
};

// Get comment with full reply tree
export const getCommentTree = async (payload) => {
  const response = await Axios.post("/comments/tree", payload);
  return response.data;
};

// Save like to comment
export const saveCommentLike = async (payload) => {
  const response = await Axios.post("/comments/likes/save", payload);
  return response.data;
};

// Delete like from comment
export const deleteCommentLike = async (payload) => {
  const response = await Axios.post("/comments/likes/delete", payload);
  return response.data;
};